import {SnackbarMessage} from 'atoms/snackbar';
import {t} from 'i18next';

import {isSafeLaunchUrl} from './appUtils';
import {AppPublishResult} from './publishApp';

export const appPublishSuccessSnackbar = (result: AppPublishResult): SnackbarMessage => {
  const launchUrl = isSafeLaunchUrl(result.launchUrl) ? result.launchUrl : undefined;

  return {
    text: t('apps_publish_success_snackbar'),
    ...(launchUrl
      ? {
          action: {
            text: t('apps_open_app'),
            to: launchUrl,
            openInNewTab: true,
          },
        }
      : {}),
  };
};
